import { useQuery } from '@tanstack/react-query';
import { api } from './api';

export interface Stat {
  median: number | null;
  p90: number | null;
  n: number;
}
export interface Performance {
  direction: { _id: string; name: string; stations: Array<{ _id: string; name: string }> };
  days: number;
  day: 'week' | 'weekend';
  days_with_data: number;
  trips: number;
  trips_per_day: number;
  travel: Stat & { by_hour: Array<Stat & { h: number }> };
  headway: Stat & { bunched: number; by_hour: Array<Stat & { h: number; bunched: number }> };
  segments: Array<Stat & { from: string; to: string }>;
  offsets: Array<{ station: string; minutes: number; known: boolean }>;
  punctuality: {
    has_timetable: boolean;
    n: number;
    on_time: number;
    early: number;
    late: number;
    median: number | null;
    by_station: Array<Stat & { station: string; name: string; on_time: number }>;
    by_hour: Array<{ h: number; n: number; on_time: number }>;
    limits: { early: number; late: number };
  };
}

export function usePerformance(id: string | undefined, days: number, day: 'week' | 'weekend') {
  return useQuery({
    queryKey: ['performance', id, days, day],
    queryFn: () => api<Performance>(`/performance/directions/${id}`, { query: { days, day } }),
    enabled: !!id,
    staleTime: 5 * 60_000,
  });
}
